export const MARKETING_ACTION_TABLE_COMPONENTS_NAMESPACE = "marketing-action-table-components";

export const MARKETING_ACTION_TABLE_COMMON_TK = "MARKETING_ACTION_TABLE_COMMON_TK";
export const MARKETING_ACTION_TABLE_OFFER_TK = "MARKETING_ACTION_TABLE_OFFER_TK";
export const MARKETING_ACTION_TABLE_SPONSORED_AD_TK = "MARKETING_ACTION_TABLE_SPONSORED_AD_TK";
